import React from 'react';
import lineDesign1 from '../assets/images/archLineDesign-2.webp';
import pinkOrbHalf from '../assets/images/BackgroundPinkRedOrbFull.svg';

const ContentBackground = ({ children }) => {
  return (
    <div className="w-[calc(100%+2rem)] h-full flex flex-col flex-grow -ml-4">
      <div className="w-full h-full bg-gray-50 border border-gray-200 rounded-lg flex flex-col flex-grow pr-5 relative overflow-hidden">
        <img
            src={lineDesign1}
            alt='line design'
            className='absolute -bottom-1 left-[0%] pointer-events-none w-[25vw] max-w-[300px] max-h-[500px] opacity-0 z-0'
        />
        <img
            src={pinkOrbHalf}
            alt='pink orb'
            className='absolute -bottom-1 right-[-3%] pointer-events-none w-[20vw] max-w-[250px] max-h-[400px] z-0 opacity-0'
        />
        
        <div className="p-6 flex-grow relative z-10 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ContentBackground;
